<template>
  <div>
    <q-row :gutter="10">
      <q-form
        ref="postDetail"
        :model="model"
        :rules="contentRules"
        label-width="20px"
        label-position="top"
      >
        <q-col :span="6">
          <q-panel
            :header-text="this.$qt('post.detail.data.title')"
            class="panel"
          >
            <div class="panel-padding">
              <q-form-item
                :label="this.$qt('post.detail.data.key')"
                prop="key"
              >
                <q-input
                  v-model="model.key"
                  :placeholder="this.$qt('post.detail.data.keyPlaceholder')"
                />
              </q-form-item>

              <q-form-item
                :label="this.$qt('post.detail.data.language')"
              >
                <q-model-selector
                  v-model="currentLanguage"
                  plugin="gausaka"
                  delegate="getLanguages"
                  display-field="name"
                  value-field="cultureName"
                  :placeholder="this.$qt('post.detail.data.language')"
                  style="width: 100%"
                />
              </q-form-item>

              <q-form-item
                v-if="inLanguage !== undefined"
                :label="this.$qt('post.detail.data.version')"
              >
                <q-item-selector
                  v-model="currentVersionNumber"
                  :items="inLanguage.versions"
                  display-field="editedTime"
                  value-field="versionNumber"
                  :placeholder="this.$qt('post.detail.data.version')"
                  style="width: 100%"
                />
              </q-form-item>

              <q-form-item
                :label="this.$qt('post.detail.data.classification')"
                prop="category"
              >
                <q-model-selector
                  v-model="model.classificationId"
                  plugin="edms"
                  delegate="getClassifications"
                  display-field="subject"
                  value-field="id"
                  :placeholder="this.$qt('post.detail.data.classification')"
                  style="width: 100%"
                />
              </q-form-item>

              <q-json>{{ model.categoryKey }}</q-json>
              <q-form-item
                :label="this.$qt('post.detail.data.categoryTitle')"
                prop="category"
              >
                <q-model-tree
                  v-model="model.categoryKey"
                  children="childes"
                  label="title"
                  value-field="key"
                  property-key="categoryKey"
                  plugin="edms"
                  delegate="getCategoriesForBlogList"
                  :fetch-data="{
                    archive: 'blog'
                  }"
                  result-key="categories"
                />
              </q-form-item>
              <q-form-item
                :label="this.$qt('post.detail.data.bgColorTitle')"
                prop="bgColor"
              >
                <q-color-picker
                  v-model="model.bgColor"
                  :placeholder="this.$qt('post.detail.data.bgColorPlaceholder')"
                />
              </q-form-item>
              <q-form-item
                :label="this.$qt('post.detail.data.colorTitle')"
                prop="color"
              >
                <q-color-picker
                  v-model="model.color"
                  :placeholder="this.$qt('post.detail.data.colorPlaceholder')"
                />
              </q-form-item>

              <q-form-item
                :label="this.$qt('post.detail.data.tagsTitle')"
                prop="tags"
              >
                <!--                <q-select-->
                <!--                  v-model="model.tags"-->
                <!--                  multiple-->
                <!--                  filterable-->
                <!--                  allow-create-->
                <!--                  default-first-option-->
                <!--                  :placeholder="this.$qt('post.detail.data.tagsPlaceholder')"-->
                <!--                >-->
                <!--                  <q-option-->
                <!--                    v-for="item in tags"-->
                <!--                    :key="item.key"-->
                <!--                    :label="item.value"-->
                <!--                    :value="item.key"-->
                <!--                  />-->
                <!--                </q-select>-->
              </q-form-item>

              <q-form-item
                :label="this.$qt('post.detail.data.thumbnailTitle')"
                prop="thumbnail"
              >
                <q-upload
                  v-model="model.thumbnail"
                  type="image"
                />

                <img
                  v-if="model.thumbnail"
                  :src="model.thumbnail"
                  width="200px"
                  alt=""
                >
              </q-form-item>

              <q-form-item
                :label="this.$qt('post.detail.data.imageTitle')"
                prop="image"
              >
                <q-upload
                  v-model="model.image"
                  type="image"
                />

                <img
                  v-if="model.image"
                  :src="model.image"
                  width="200px"
                  alt=""
                >
              </q-form-item>

              <div v-if="model.seo !== undefined">
                <q-form-item
                  :label="this.$qt('post.detail.data.seoTitle')"
                  prop="seoTitle"
                >
                  <q-input
                    v-model="model.seo.title"
                    :placeholder="this.$qt('post.detail.data.seoTitlePlaceholder')"
                  />
                </q-form-item>

                <q-form-item
                  :label="this.$qt('post.detail.data.seoDescriptionTitle')"
                  prop="seoDescription"
                >
                  <q-input
                    v-model="model.seo.description"
                    type="textarea"
                    :rows="4"
                    :placeholder="this.$qt('post.detail.data.seoDescriptionPlaceholder')"
                  />
                </q-form-item>

                <q-form-item
                  :label="this.$qt('post.detail.data.seoKeywordsTitle')"
                  prop="seoKeywords"
                >
                  <q-input
                    v-model="model.seo.keywords"
                    type="textarea"
                    :rows="6"
                    :placeholder="this.$qt('post.detail.data.seoKeywordsPlaceholder')"
                  />
                </q-form-item>
              </div>
            </div>
          </q-panel>
        </q-col>
        <q-col :span="18">
          <div v-if="currentVersion !== undefined">
            <q-panel
              :header-text="this.$qt('post.detail.generalTitle')"
              class="panel"
            >
              <div class="panel-padding">
                <q-form-item
                  prop="title"
                >
                  <q-input
                    v-model="currentVersion.subject"
                    :disabled="false"
                    :placeholder="this.$qt('post.detail.titlePlaceholder')"
                  />
                </q-form-item>

                <q-form-item
                  prop="textType"
                >
                  <q-select
                    v-model="currentVersion.textType"
                  >
                    <q-option
                      :label="this.$qt('post.detail.textType.marked')"
                      value="Marked"
                    />
                    <q-option
                      :label="this.$qt('post.detail.textType.html')"
                      value="Html"
                    />
                    <q-option
                      :label="this.$qt('post.detail.textType.text')"
                      value="Text"
                    />
                  </q-select>
                </q-form-item>

                <q-form-item
                  prop="text"
                >
                  <template v-if="currentVersion.textType === 'Marked'">
                    <q-input
                      v-model="currentVersion.text"
                      dir="ltr"
                      type="textarea"
                      :rows="25"
                      :placeholder="this.$qt('post.detail.markedContentPlaceholder')"
                    />
                  </template>
                  <template v-else-if="currentVersion.textType === 'Html'">
                    <q-input
                      v-model="currentVersion.text"
                      dir="ltr"
                      type="textarea"
                      :rows="25"
                      :placeholder="this.$qt('post.detail.htmlContentPlaceholder')"
                    />
                  </template>
                  <template v-else>
                    <q-input
                      v-model="currentVersion.text"
                      type="textarea"
                      :rows="25"
                      :placeholder="this.$qt('post.detail.textContentPlaceholder')"
                    />
                  </template>
                </q-form-item>

                <q-form-item
                  prop="summary"
                >
                  <q-input
                    v-model="currentVersion.summary"
                    type="textarea"
                    :rows="4"
                    :disabled="false"
                    :placeholder="this.$qt('post.detail.summaryPlaceholder')"
                  />
                </q-form-item>
              </div>
            </q-panel>

            <q-panel
              :header-text="this.$qt('post.detail.commentsTitle')"
              class="panel"
            >
              <div class="panel-padding">
                <q-form-item
                  prop="comments"
                >
                  <q-composite-list
                    v-model="model.comments"
                    structure-key="comment"
                  />
                </q-form-item>
              </div>
            </q-panel>
          </div>
          <div v-else>
            <span>Please select language and version</span>
          </div>
        </q-col>
      </q-form>
    </q-row>
  </div>
</template>

<script>
  import marked from "marked";
  import upload from "../../../../../components/upload";

  export default {
    name: "QContentEditor",

    components: {
      'q-upload': upload,
    },

    props: {
      value: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        model: undefined,
        currentLanguage: undefined,
        currentVersionNumber: undefined,
        currentVersion: undefined,
        inLanguage: undefined,
        contentRules: {
          title: [
            {required: true, message: 'عنوان را وارد کنید', trigger: 'blur'},
          ],
        }
      }
    },

    computed: {
      compiledMarkdown() {
        if (this.model.text)
          return marked(this.model.text, {sanitize: true});
        else
          return '';
      }
    },

    watch: {
      model() {
        this.$emit('input', this.model);
      },
      value() {
        this.model = this.value;
      },
      currentLanguage() {
        if (!this.model.languages)
          return undefined;

        let xx = this.model.languages.find((lang) => {
          return lang.language === this.currentLanguage;
        });

        this.inLanguage = xx;
        this.currentVersionNumber = undefined;
        this.currentVersion = undefined;
      },
      currentVersionNumber(){
        if(!this.inLanguage.versions)
          return undefined;

        let xx = this.inLanguage.versions.find((ver)=>{
          return ver.versionNumber === this.currentVersionNumber;
        });

        this.currentVersion = xx;
      }
    },

    created() {
      this.model = this.value;
    },
  }
</script>

<style scoped>

</style>